module.exports = __webpack_public_path__ + "img/logo.d9f2fa7f.png";